import { I18n } from "@aws-amplify/core";
import { get, includes, forEach, keys } from "lodash";

import { getUser } from "./users";

import { driveInOut } from "../constants/reducers";
import { date } from "../constants/common";
import { driveInOutFields, walkInOutFields } from "../resources/SiteLogFields";
import { nowWithOutSeconds } from "./date";

export const extractValuesFromData = async (values, group) => {
  Object.keys(group).forEach((field) => {
    if (group[field] !== null) {
      Object.keys(group[field]).forEach((subField) => {
        if (!values[field]) {
          values[field] = {};
        }
        if (group[field][subField] !== "") {
          if (!values[field][subField]) {
            values[field][subField] = [group[field][subField]];
          } else if (
            !values[field][subField].includes(group[field][subField])
          ) {
            values[field][subField].push(group[field][subField]);
          }
        }
        if (subField === "verified") {
          values[field].verified = [
            I18n.get("site_fuelLevel"),
            I18n.get("site_odometer"),
            I18n.get("site_seal"),
            I18n.get("site_temperatures"),
          ];
        }
      });
    }
  });
  if (!values.main) {
    values.main = {};
  }

  // Fetch processed by users
  values.main.processedBy = [];
  if (group.main.processedBy) {
    let response = await getUser(group.main.processedBy);
    let processedBy =
      response.profile.firstname + " " + response.profile.lastname;
    if (!values.main.processedBy.includes(processedBy)) {
      values.main.processedBy.push(processedBy);
    }
    group.main.processedBy = processedBy;
  }

  // Fetch overriden by users
  //await fetchOverridenByUsers([group])
  return values;
};

// Set filters from values
export const setFiltersFromValues = (name, values) => {
  let filters = {};
  let fields =
    name === driveInOut ? driveInOutFields.fields : walkInOutFields.fields;
  let subFields =
    name === driveInOut
      ? driveInOutFields.subFields
      : walkInOutFields.subFields;
  let verified =
    name === driveInOut ? driveInOutFields.verified : walkInOutFields.verified;
  fields.slice(0, fields.length - 1).forEach((field) => {
    filters[field.name] = {};
    subFields[field.subFieldsId].forEach((subField) => {
      if (subField.filterType) {
        if (subField.filterType === "select") {
          filters[field.name][subField.name] = {
            filter: subField.name === "active" ? [true] : ["all"],
            type: subField.filterType,
            values: values[field.name] ? values[field.name][subField.name] : [],
          };
        } else if (subField.filterType === "search") {
          filters[field.name][subField.name] = {
            filter: "",
            type: subField.filterType,
          };
        } else if (subField.filterType === "date") {
          filters[field.name][subField.name] = {
            startDate: nowWithOutSeconds(),
            endDate: nowWithOutSeconds(),
            type: subField.filterType,
          };
        }
      }
    });
    verified.forEach((subField) => {
      if (subField.filterType) {
        if (subField.filterType === "select") {
          filters[field.name][subField.name] = {
            filter: ["all"],
            type: subField.filterType,
            values: values[field.name] ? values[field.name][subField.name] : [],
          };
        } else if (subField.filterType === "search") {
          filters[field.name][subField.name] = {
            filter: "",
            type: subField.filterType,
          };
        } else if (subField.filterType === "date") {
          filters[field.name][subField.name] = {
            startDate: nowWithOutSeconds(),
            endDate: nowWithOutSeconds(),
            type: subField.filterType,
          };
        }
      }
    });
  });
  return filters;
};

export const mergeFiltersWithValues = (filters, values) => {
  forEach(keys(filters), (field) => {
    forEach(keys(filters[field]), (subField) => {
      if (get(filters, [field, subField, "type"]) === "select") {
        if (filters[field][subField].values === undefined) {
          filters[field][subField].values = [];
        }
        forEach(get(values, [field, subField]), (v) => {
          if (
            v !== undefined &&
            !includes(get(filters, [field, subField, "values"]), v)
          ) {
            filters[field][subField].values.push(v);
          }
        });
      }
    });
  });
  // Object.keys(filters).forEach((field) => {
  //   Object.keys(filters[field]).forEach((subField) => {
  //     if (
  //       filters[field][subField].type === "select" &&
  //       filters[field][subField].values &&
  //       values[field] &&
  //       values[field][subField] &&
  //       values[field][subField].length > 0 &&
  //       !filters[field][subField].values.includes(values[field][subField][0])
  //     ) {
  //       filters[field][subField].values.push(values[field][subField][0]);
  //     }
  //   });
  // });
  return filters;
};

export const setRequestFilters = (body, filters) => {
  if (filters) {
    Object.keys(filters).forEach((field) => {
      if (filters[field]) {
        Object.keys(filters[field]).forEach((subField) => {
          let filter = get(filters, [field, subField]);

          // Dates
          if (filter.type === date && filter.startDate && filter.endDate) {
            let filterName;
            if (subField === "dateTime") filterName = "created_on";
            if (subField === "modified_on") filterName = "processed_on";
            if (filterName) {
              body.filter2[field === "main" ? "log" : field][filterName] = {
                operation: "between",
                values: [filter.startDate, filter.endDate],
              };
            }
          }

          // Select
          // if (filter.type === select) {
          //   let filterName;
          //   if (subField === "entryStatus") filterName = "authorization"
          //   if (filterName) {
          //     body.filter2[field === "main" ? "log" : field][filterName] = {
          //       operation: "==",
          //       values:
          //     }
          //   }
          // }
        });
      }
    });
  }
  return body;
};
